"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3416,2428],{

/***/ 80651:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    height: 300,
    width: 300,
    link: {}
});


/***/ }),

/***/ 94351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ GridImage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/picture-with-link/picture-with-link-component.js
var picture_with_link_component = __webpack_require__(94640);
// EXTERNAL MODULE: ./segments/desktop/core-components/images-grid/images-grid-service.js
var images_grid_service = __webpack_require__(72898);
// EXTERNAL MODULE: ./segments/desktop/core-components/grid-image/default-props.js
var default_props = __webpack_require__(80651);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-image/grid-image.scss.js

var StyledGridImage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ezk0g6e0"
})("display:flex;.image{width:100%;}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-image/grid-image.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}






var GridImage = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(GridImage, PureComponent);
    var _super = (0,_create_super/* default */.Z)(GridImage);
    function GridImage() {
        (0,_class_call_check/* default */.Z)(this, GridImage);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(GridImage, [
        {
            key: "renderPicture",
            value: function renderPicture() {
                var _props = this.props, src = _props.src, alt = _props.alt, isDecorative = _props.isDecorative, link = _props.link, imageStyle = _props.imageStyle;
                var href = link.href, isNewTab = link.isNewTab;
                var target = isNewTab ? "_blank" : "_self";
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_with_link_component/* default */.Z, {
                    src: src,
                    alt: alt,
                    isDecorative: isDecorative,
                    className: "image",
                    target: target,
                    href: href,
                    specificImageStyle: imageStyle
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, height = _props.height, width = _props.width, imagePosition = _props.imagePosition;
                var imagePositionStyles = (0,images_grid_service/* getImagePositionStyles */.y)(imagePosition);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGridImage, {
                    className: "grid-image",
                    style: _object_spread({
                        height: height,
                        width: width
                    }, imagePositionStyles),
                    children: this.renderPicture()
                });
            }
        }
    ]);
    return GridImage;
}(react.PureComponent);

GridImage.defaultProps = default_props/* default */.Z;


/***/ }),

/***/ 32627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ grid_paragraph_with_image; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./segments/desktop/core-components/grid-image/grid-image.js + 1 modules
var grid_image = __webpack_require__(94351);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./segments/desktop/constants.js
var constants = __webpack_require__(73759);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-paragraph-with-image/grid-paragraph-with-image.scss.js




var StyledGridParagraphWithImage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e17e2hrn0"
})("text-decoration:none;color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";height:100%;width:100%;display:flex;&.without-link{.grid-paragraph-with-image{cursor:initial;}}.grid-paragraph-with-image{display:flex;flex-direction:column;height:100%;width:100%;cursor:pointer;border-radius:18px;overflow:hidden;&.top{justify-content:flex-start;}&.center{justify-content:center;}&.bottom{justify-content:flex-end;}.tag{border-style:solid;border-width:2px;position:absolute;top:10px;right:10px;padding:3px 5px;}&:not(.without-shadow-hover):hover{", (0,constants.getComponentShadow)(), "}&.shadow{", (0,constants.getComponentShadow)(), "      &:not(.without-shadow-hover):hover{", (0,constants.getComponentShadowWithHoverEffect)(), "}}.grid-image-wrapper{.grid-image{.picture-component{display:flex;img{border-bottom-right-radius:16px;border-bottom-left-radius:16px;}}}}.grid-paragraph-wrapper{height:100%;padding:24px 24px 40px 24px;display:flex;flex-direction:column;.full-paragraph-topic-image-wrapper.left .picture-component > img{object-fit:contain;}.footer{display:flex;align-items:center;margin-top:10px;gap:10px;.footer-image{width:", function(param) {
    var footerImageWidth = param.footerImageWidth;
    return footerImageWidth !== null && footerImageWidth !== void 0 ? footerImageWidth : "auto";
}, ";height:auto;}}}}&.disabled-hover-effect{cursor:initial;.grid-paragraph-with-image{cursor:initial;&:hover{box-shadow:none;}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/grid-image/default-props.js
var default_props = __webpack_require__(80651);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/default-props.js
var title_default_props = __webpack_require__(51261);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/default-props.js
var paragraph_default_props = __webpack_require__(14066);
;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-paragraph-with-image/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var grid_paragraph_with_image_default_props = (_object_spread_props(_object_spread({}, default_props/* default */.Z), {
    showParagraph: true,
    fullParagraph: _object_spread({}, title_default_props/* default */.Z, paragraph_default_props/* default */.Z),
    cardColor: color_consts.WHITE_COLOR_NAME
}));

// EXTERNAL MODULE: ./utils/general.js
var general = __webpack_require__(56093);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js + 11 modules
var monday_markup_language_component = __webpack_require__(36239);
;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-paragraph-with-image/grid-paragraph-with-image.js
function grid_paragraph_with_image_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function grid_paragraph_with_image_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            grid_paragraph_with_image_define_property(target, key, source[key]);
        });
    }
    return target;
}
function grid_paragraph_with_image_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function grid_paragraph_with_image_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        grid_paragraph_with_image_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}












var GridParagraphWithImage = function(props) {
    var borderColor = props.borderColor, showParagraph = props.showParagraph, fullParagraph = props.fullParagraph, titleSize = props.titleSize, textSize = props.textSize, cardTagText = props.cardTagText, contentVerticalAlignment = props.contentVerticalAlignment, paragraphVerticalColoredLineColor = props.paragraphVerticalColoredLineColor, padding = props.padding, backgroundImage = props.backgroundImage, cardColor = props.cardColor, borderOpacity = props.borderOpacity, cardWidthForCss = props.cardWidthForCss, disableHoverStyle = props.disableHoverStyle, footer = props.footer, imageOnTop = props.imageOnTop;
    var ref = (fullParagraph === null || fullParagraph === void 0 ? void 0 : fullParagraph.buttonConfig) || {}, url = ref.url, isOpenLinkInNewTab = ref.isOpenLinkInNewTab, buttonText = ref.buttonText;
    var handleClick = function() {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.FLEXIBLE_GRID_CARD_CLICKED, {
            kind: buttonText,
            info1: fullParagraph === null || fullParagraph === void 0 ? void 0 : fullParagraph.title,
            info2: url
        });
        url && window.open(url, isOpenLinkInNewTab ? "_blank" : "_self");
    };
    var getParagraphStyle = function() {
        return {
            padding: padding
        };
    };
    var getStyle = function() {
        var color = colors/* default */.Z[cardColor];
        var borderRgbaColor = borderColor === colors/* default.transparent */.Z.transparent ? borderColor : borderColor && (0,general/* hexToRgba */.a7)(colors/* default */.Z[borderColor], parseFloat(borderOpacity) || 1);
        var style = {
            backgroundColor: color,
            maxWidth: cardWidthForCss,
            border: "1px solid ".concat(borderRgbaColor)
        };
        if (backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.src) {
            style = grid_paragraph_with_image_object_spread_props(grid_paragraph_with_image_object_spread({}, style), {
                backgroundImage: "url(".concat(backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.src, ")"),
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: (backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.backgroundPosition) || "center"
            });
        }
        return style;
    };
    var renderParagraph = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: showParagraph && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("grid-paragraph-wrapper"),
                style: getParagraphStyle(),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, grid_paragraph_with_image_object_spread_props(grid_paragraph_with_image_object_spread({
                        titleSize: titleSize,
                        textSize: textSize
                    }, fullParagraph), {
                        paragraphVerticalColoredLineColor: paragraphVerticalColoredLineColor
                    })),
                    (footer === null || footer === void 0 ? void 0 : footer.showFooter) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "footer",
                        children: [
                            (footer === null || footer === void 0 ? void 0 : footer.image) && /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                className: "footer-image",
                                src: footer === null || footer === void 0 ? void 0 : footer.image
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
                                className: "footer-text",
                                text: footer === null || footer === void 0 ? void 0 : footer.text
                            })
                        ]
                    })
                ]
            })
        });
    };
    var renderComponent = function() {
        var shadowCards = props.shadowCards, removeShadowOnHover = props.removeShadowOnHover, src = props.src, cardTagColor = props.cardTagColor, restImageProps = _object_without_properties(props, [
            "shadowCards",
            "removeShadowOnHover",
            "src",
            "cardTagColor"
        ]);
        var tagColor = colors/* default */.Z[cardTagColor];
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("grid-paragraph-with-image", {
                shadow: shadowCards,
                "without-shadow-hover": removeShadowOnHover
            }, contentVerticalAlignment),
            style: getStyle(),
            children: [
                cardTagText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "tag",
                    style: {
                        borderColor: tagColor,
                        color: tagColor
                    },
                    children: cardTagText
                }),
                imageOnTop && src && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid-image-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_image/* default */.Z, grid_paragraph_with_image_object_spread({
                        src: src
                    }, restImageProps))
                }),
                renderParagraph(),
                !imageOnTop && src && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid-image-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_image/* default */.Z, grid_paragraph_with_image_object_spread({
                        src: src
                    }, restImageProps))
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGridParagraphWithImage, {
        className: classnames_default()("card-grid-link", {
            "without-link": !url,
            "disabled-hover-effect": disableHoverStyle
        }),
        onClick: handleClick,
        rel: "noreferrer",
        footerImageWidth: footer === null || footer === void 0 ? void 0 : footer.imageWidth,
        children: renderComponent()
    });
};
GridParagraphWithImage.defaultProps = grid_paragraph_with_image_object_spread({}, grid_paragraph_with_image_default_props);
/* harmony default export */ var grid_paragraph_with_image = (GridParagraphWithImage);


/***/ }),

/***/ 47953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sliding_card_grid_component; }
});

// EXTERNAL MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.js + 1 modules
var responsive_hoc_component = __webpack_require__(27190);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/default-props.js

var cards = [
    {
        fullParagraph: {
            topic: {
                text: "01"
            },
            title: "Set marketing goals & strategy",
            body: "Work collaboratively with internal and external stakeholders to define high-level goals and strategies."
        },
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/marketing%20solution/3-Marketing_card.png"
    },
    {
        fullParagraph: {
            topic: {
                text: "02"
            },
            title: "Set marketing goals & strategy",
            body: "Work collaboratively with internal and external stakeholders to define high-level goals and strategies."
        },
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/marketing%20solution/4-Marketing_card.png"
    },
    {
        fullParagraph: {
            topic: {
                text: "03"
            },
            title: "Set marketing goals & strategy",
            body: "Work collaboratively with internal and external stakeholders to define high-level goals and strategies."
        },
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/marketing%20solution/2-Marketing_card.png"
    },
    {
        fullParagraph: {
            topic: {
                text: "04"
            },
            title: "Set marketing goals & strategy",
            body: "Work collaboratively with internal and external stakeholders to define high-level goals and strategies."
        },
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/marketing%20solution/5-Marketing_card.png"
    }
];
/* harmony default export */ var default_props = ({
    borderColor: color_consts.UI_BORDER_LIGHT_COLOR_NAME,
    cards: cards
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/components/sliding-card-grid-base/sliding-card-grid-base-component.js + 9 modules
var sliding_card_grid_base_component = __webpack_require__(74447);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/components/sliding-card-grid-mobile/sliding-card-grid-mobile-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var SlidingCardGridMobileComponent = function(_param) {
    var cardsToShow = _param.cardsToShow, isFullScreen = _param.isFullScreen, rest = _object_without_properties(_param, [
        "cardsToShow",
        "isFullScreen"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(sliding_card_grid_base_component/* default */.Z, _object_spread_props(_object_spread({}, rest), {
        isFullScreen: true,
        cardsToShow: 1.2
    }));
};
/* harmony default export */ var sliding_card_grid_mobile_component = (SlidingCardGridMobileComponent);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/sliding-card-grid-component.js




var SlidingCardGridComponent = (0,responsive_hoc_component/* default */.Z)(sliding_card_grid_base_component/* default */.Z, sliding_card_grid_mobile_component);
SlidingCardGridComponent.defaultProps = default_props;
/* harmony default export */ var sliding_card_grid_component = (SlidingCardGridComponent);


/***/ }),

/***/ 72428:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    BASIC_HEADER_HEIGHT: 72,
    SECONDARY_HEADER_HEIGHT: 56,
    HEADER_CONTENT_HORIZONTAL_PADDING: 32,
    MOBILE_MINI_SITE_BASIC_HEADER_HEIGHT: 52,
    MOBILE_MINI_SITE_SECONDARY_HEADER_HEIGHT: 44,
    SIGNUP_POPUP_SCREEN_RIGHT_MARGIN: 16,
    SIGNUP_POPUP_SCREEN_WIDTH: 346,
    SIGNUP_POPUP_SCREEN_HEIGHT: 404,
    PRODUCTS_SWITCHER_SCREEN_WIDTH: 300,
    PRODUCTS_SWITCHER_NEW_USERS_SCREEN_HEIGHT: 375,
    PRODUCTS_SWITCHER_EXISTING_USERS_SCREEN_HEIGHT: 270,
    PRODUCTS_SWITCHER_SCREEN_RIGHT_MARGIN: 32
});


/***/ })

}]);